import React, { useRef } from 'react'
import { Button } from 'semantic-ui-react'
import { SetSaveEvent } from '../../../commonApis/formEvents'
import { HttpClient } from '../../../commonApis/httpClient'
import CustomPopup from '@commonComponents/customPopup'
import { useToggle } from '../../hooks'


const CreateEmergencyDocument = (props) => {
  const {
    children,
    eventName = "GENERATE_EMERGENCY_PROCEDURE_DOCUMENT_NL",
    params = {},
    callback,
    isParentDiv = true
  } = props
  const popup = useRef()
  const [toggleValue, setToggleValue] = useToggle(false)

  const genrateDV1FormPDF = async () => {
    popup.current?.closePopup()
    setToggleValue()
    const data = SetSaveEvent(eventName, { "shipmentId": window.shipmentId, ...params })
    const response = await HttpClient.custom({ data })
    setToggleValue()
    const url = response?.data?.eventMessage?.url
    if (url) {
      const pdfWindow = window.open()
      pdfWindow.location.href = url
      callback && callback()
    }
    //  else
    //  showToast('EAD document generation Failed')
  }

  const content = <>
    {children && children({
      isLoading: toggleValue,
      openConfirmationPopup: popup
    })}
    <CustomPopup
      content={false}
      ref={popup}
      className="confirmationPopup"
      header={<div> Are you sure custom system is down?</div>}
      actions={
        <div className="actions">
          <Button positive onClick={genrateDV1FormPDF}>
            YES
          </Button>
          <Button negative onClick={() => popup.current?.closePopup()}>
            NO
          </Button>
        </div>
      } >
    </CustomPopup>
  </>
  
  return isParentDiv ?
    <div className='emergency'>
      {content}
    </div> : content
}


export default CreateEmergencyDocument